import { createSelector } from '@reduxjs/toolkit'

const getStateProductExportAllById = state => state.products.exportAllById

export const getProductExportAllById = createSelector(
  [getStateProductExportAllById],
  product => product
)
